export default __webpack_public_path__ + "static/media/anyni1.6f64a4f1.jpeg";